import { useState } from 'react'
import axios from 'axios'
import { RotatingLines } from 'react-loader-spinner'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import Button from '../utils/Button'
import Modal from '../utils/Modal'
import '../../styles/Admin/AdminUserDelete.css'

function AdminUserDelete({ user, getUsers }) {

    const [isLoading, setIsLoading] = useState(false)
    const [displayModal, setDisplayModal] = useState(false)

    function deleteUser(userId) {

        setIsLoading(true)
        const toastId = toast.loading("Suppression...")
        axios.delete(process.env.REACT_APP_API_URL + "user/" + userId).then((response) => {
            console.log("response.data :\n" + JSON.stringify(response.data) + "\n\n")
            if (response.data === 'USER_DELETED') {
                getUsers()
                toast.update(toastId, { render: "Utilisateur supprimé", type: "success", isLoading: false, autoClose: 5000 })
            }
            setIsLoading(false)
        }).catch((error) => {
            if (error.response) {
                console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                var errorMessage = error.response.data.message
                if (errorMessage === 'USER_NOT_FOUND') {
                    errorMessage = "L'utilisateur est introuvable"
                } else if (errorMessage === 'ERROR_USER_DELETING') {
                    errorMessage = "Erreur lors de la suppression de l'utilisateur"
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 })
            }
            setIsLoading(false)
        })

    }

    return (

        <div id='adminUserDelete'>
            <Modal
                displayModal={displayModal}
                setDisplayModal={setDisplayModal}
                buttonDisplayType={'danger'}
                buttonDisplayIcon={<FontAwesomeIcon icon={faTrash} />}
                buttonDisplayText={"Supprimer"}
                header={"Supprimer " + user.firstname + " " + user.lastname}
                body={
                    <>
                        Êtes vous sur de supprimer l'utilisateur :
                        <br /><br />
                        Prénom : {user.firstname}
                        <br />
                        Nom : {user.lastname}
                        <br />
                        Email : {user.email}
                        <br />
                        Rôle : {user.role}
                    </>
                }
                footer={
                    <>
                        {isLoading ?
                            <RotatingLines
                                strokeColor="#e2e9f0"
                                strokeWidth="5"
                                animationDuration="1"
                                width="40"
                                visible={true}
                            />
                            :
                            <Button
                                type={'danger'}
                                icon={<FontAwesomeIcon icon={faTrash} />}
                                text={'Supprimer'}
                                onClick={() => deleteUser(user.id)}
                            />
                        }
                    </>
                }
            />
        </div>
    )

}

export default AdminUserDelete
